import { EmployeeState } from './state';

export const employeeInitialState: EmployeeState = {
  listEmployee: [],
  currentEmployee: undefined,
};
